export const DEFAULT_SEARCH_API_URL = "/vnext/searchApi/graphql";
